export const SERVING_STYLE = {
  INDIVIDUAL: 'Individually Packaged',
  FAMILY: 'Family Style',
};

export const STRIPE_STYLE = {
  STRIPE_PAYMENT_SUCCESS: 'customer_paid',
};
